<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>派送方式</span>
          </div>
          <el-table
            :data="pagedDistributionModes"
            style="width: 100%"
            border
            stripe
          >
            <el-table-column prop="modeId" label="派送方式ID" align="center"></el-table-column>
            <el-table-column prop="modeName" label="方式名称" align="center"></el-table-column>
            <el-table-column prop="fixedFee" label="固定费" align="center">
              <template slot-scope="scope">
                {{scope.row.fixedFee === '-1.00' ? '-' : scope.row.fixedFee}}
              </template>
            </el-table-column>
            <el-table-column prop="startDeliveryIn" label="起送1公里内" align="center">
              <template slot-scope="scope">
                {{scope.row.startDeliveryIn === '-1.00' ? '-' : scope.row.startDeliveryIn}}
              </template>
            </el-table-column>
            <el-table-column prop="startDeliveryOut" label="起送1公里后每公里" align="center">
              <template slot-scope="scope">
                {{scope.row.startDeliveryOut === '-1.00' ? '-' : scope.row.startDeliveryOut}}
              </template>
            </el-table-column>
            <el-table-column prop="maximumDistribution" label="最大配送公里" align="center">
              <template slot-scope="scope">
                {{scope.row.maximumDistribution === '-1.00' ? '-' : scope.row.maximumDistribution}}
              </template>
            </el-table-column>
            <el-table-column label="配送类型" align="center">
              <template slot-scope="scope">
                {{ deliveryTypeName(scope.row.deliveryType) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="120">
              <template slot-scope="scope">
                <el-button size="mini" @click="openEditDistributionModeModel(scope.row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="distributionModes.length"
            style="margin-top: 20px; text-align: right;"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <edit-distribution-mode ref="editDistributionMode" @refresh="listDistributionModes"></edit-distribution-mode>
  </div>
</template>

<script>
/*
 * 服务码调用点清单（Task 21B，REQ20260904014）：
 * 1. shop.queryShop —— 列表数据源（经 api/goods/distributionModeApi.listDistributionMode 适配，
 *    取响应内嵌 distributionModeDtos；原 distributionMode.listDistributionMode 为历史死码，后端无实现）
 * 2. shop.updateDistributionMode —— 编辑弹窗提交（商户态修改配送方式配置，deliveryType 必选参与定位）
 */
import { getShopId } from '@/api/shop/shopApi'
import { listDistributionMode } from '@/api/goods/distributionModeApi'
import EditDistributionMode from '@/components/goods/editDistributionMode/editDistributionMode'

export default {
  name: 'DistributionModeManage',
  components: {
    EditDistributionMode
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      distributionModes: []
    }
  },
  computed: {
    pagedDistributionModes() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.distributionModes.slice(start, start + this.pageSize)
    }
  },
  created() {
    this.listDistributionModes()
  },
  methods: {
    deliveryTypeName(deliveryType) {
      if (deliveryType === 'STORE') {
        return '商家自配送'
      }
      if (deliveryType === 'PROPERTY') {
        return '物业配送'
      }
      return deliveryType || '-'
    },
    async listDistributionModes() {
      try {
        const res = await listDistributionMode({ shopId: getShopId(), page: 1, row: 1 })
        this.distributionModes = res.data || []
        this.currentPage = 1
      } catch (error) {
        console.error('获取派送方式列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    openEditDistributionModeModel(row) {
      this.$refs.editDistributionMode.open(row)
    }
  }
}
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>
